import { useRequest } from 'ahooks'

import { deleteAnnouncementApi } from '@eastcoal/api/trade/announcementOperation/deleteAnnouncement'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { AnnouncementDeleteBatchButtonProps } from './interface'

export const AnnouncementDeleteBatchButton = ({
  uuid
}: AnnouncementDeleteBatchButtonProps) => {
  const { message } = useFeedback()

  const { selectedRowKeys, setSelectedRows, reload } = useRemoteTableStore(
    state => pick(state, ['selectedRowKeys', 'setSelectedRows', 'reload'])
  )

  const { loading, runAsync } = useRequest(
    () =>
      deleteAnnouncementApi({
        ids: selectedRowKeys as string[]
      }),
    {
      manual: true,
      onSuccess() {
        message.success('批量删除成功')
        setSelectedRows([])
        reload()
      }
    }
  )

  return (
    <ConfirmButton
      danger
      disabled={selectedRowKeys.length === 0}
      forbiddenStrategy='disable'
      loading={loading}
      message='确定批量删除吗？'
      placement='top'
      type='default'
      uuid={uuid}
      onConfirm={runAsync}
    >
      批量删除
    </ConfirmButton>
  )
}
